(() => {
  const doc = document;
  const successLink = doc.querySelector('[data-ffo-b2b-success] a');
  if (successLink) window.location.assign(successLink.href);
  const config = JSON.parse(doc.querySelector('[data-ffo-config]')?.textContent || '{}');
  const root = config.root || '/';
  const route = (path) => `${root.replace(/\/$/, '')}/${path}`;
  const money = (cents) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cents / 100);
  function bindHeader() {
    doc.querySelectorAll('[data-ffo-header]').forEach(header => {
      if (header.dataset.bound) return;
      header.dataset.bound = 'true';
      const dialog = header.querySelector('[data-ffo-menu]');
      const scroller = dialog.querySelector('[data-ffo-menu-scroll]');
      const open = header.querySelector('[data-ffo-menu-open]');
      const close = header.querySelector('[data-ffo-menu-close]');
      let previous = null;
      let scheduled = false;
      const update = () => {
        header.classList.toggle('is-solid', window.scrollY > 48);
        scheduled = false;
      };
      window.addEventListener('scroll', () => {
        if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
      }, { passive: true });
      window.addEventListener('resize', () => {
        if (dialog.open && window.matchMedia('(min-width: 1100px)').matches) closeMenu();
        update();
      });
      update();
      function reset() {
        dialog.querySelectorAll('details').forEach(item => item.open = false);
        scroller.scrollTop = 0;
      }
      open.addEventListener('click', () => {
        if (dialog.open) return;
        reset();
        dialog.style.setProperty('--ffo-menu-offset', Math.max(0, header.getBoundingClientRect().top) + 'px');
        previous = { y: window.scrollY, style: doc.body.getAttribute('style') };
        doc.body.style.position = 'fixed';
        doc.body.style.top = '-' + previous.y + 'px';
        doc.body.style.width = '100%';
        doc.body.style.overflow = 'hidden';
        doc.body.classList.add('ffo-menu-opened');
        dialog.showModal();
        open.setAttribute('aria-expanded', 'true');
        close.focus({ preventScroll: true });
      });
      function restoreMenu() {
        if (!previous) return;
        const saved = previous;
        previous = null;
        if (saved.style === null) doc.body.removeAttribute('style');
        else doc.body.setAttribute('style', saved.style);
        doc.body.classList.remove('ffo-menu-opened');
        window.scrollTo({ top: saved.y, behavior: 'instant' });
        open.setAttribute('aria-expanded', 'false');
        reset();
        update();
        open.focus({ preventScroll: true });
      }
      function closeMenu() {
        if (dialog.open) dialog.close();
        restoreMenu();
      }
      close.addEventListener('click', closeMenu);
      dialog.addEventListener('close', restoreMenu);
      dialog.addEventListener('cancel', event => { event.preventDefault(); closeMenu(); });
      dialog.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
      dialog.querySelectorAll('.ffo-mobile-nav details').forEach(item => item.addEventListener('toggle', () => {
        if (item.open) dialog.querySelectorAll('.ffo-mobile-nav details').forEach(other => { if (other !== item) other.open = false; });
      }));
      header.querySelectorAll('.ffo-desktop-nav details').forEach(item => item.addEventListener('toggle', () => {
        if (item.open) header.querySelectorAll('.ffo-desktop-nav details').forEach(other => { if (other !== item) other.open = false; });
      }));
      doc.addEventListener('click', event => {
        if (!header.contains(event.target)) header.querySelectorAll('.ffo-desktop-nav details').forEach(item => item.open = false);
      });
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape') header.querySelectorAll('.ffo-desktop-nav details').forEach(item => item.open = false);
      });
    });
    doc.querySelectorAll('.ffo-footer').forEach(footer => {
      if (footer.dataset.bound) return;
      footer.dataset.bound = 'true';
      const mobile = window.matchMedia('(max-width: 749px)');
      const groups = footer.querySelectorAll('[data-ffo-footer-group]');
      const layout = () => groups.forEach(group => group.open = !mobile.matches);
      layout();
      mobile.addEventListener('change', layout);
      groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
        if (!mobile.matches) event.preventDefault();
      }));
    });
  }
  function shipping(cart) {
    const threshold = Number(config.shippingGoal || 49800);
    const remaining = Math.max(0, threshold - cart.total_price);
    doc.querySelectorAll('[data-ffo-shipping]').forEach(box => {
      const message = box.querySelector('[data-ffo-shipping-message]');
      if (message) message.textContent = remaining ? config.shippingLeft.replace('__AMOUNT__', money(remaining)) : config.shippingReached;
      const progress = box.querySelector('progress');
      if (progress) progress.value = Math.min(cart.total_price, threshold);
    });
    doc.querySelectorAll('[data-ffo-cart-count]').forEach(node => { node.textContent = cart.item_count; node.hidden = cart.item_count === 0; });
  }
  let shippingRequest = 0;
  async function refreshCart() {
    const revision = ++shippingRequest;
    try {
      const response = await fetch(route('cart.js'), { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      if (revision === shippingRequest) shipping(cart);
    } catch (_) {}
  }
  function bindCards() {
    doc.querySelectorAll('form[data-ffo-add]').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button');
        const status = form.querySelector('[aria-live]');
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = '';
        try {
          const response = await fetch(route('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || config.error);
          const cartLink = doc.createElement('a');
          cartLink.href = route('cart');
          cartLink.textContent = `${config.added} · ${config.cart}`;
          status.replaceChildren(cartLink);
          await refreshCart();
          doc.dispatchEvent(new CustomEvent('cart:item-added', { detail: { product: result } }));
          if (doc.body.classList.contains('template-cart')) window.location.reload();
        } catch (error) { status.textContent = error.message || config.error; }
        finally { button.disabled = false; button.removeAttribute('aria-busy'); }
      });
    });
  }
  function bindVideo() {
    doc.querySelectorAll('[data-ffo-hero-video]').forEach(video => {
      if (video.dataset.bound) return;
      video.dataset.bound = 'true';
      const toggle = video.closest('.ffo-hero').querySelector('[data-ffo-video-toggle]');
      let loaded = false;
      let userPaused = false;
      video.dataset.ffoUserPaused = 'false';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      const start = async () => {
        if (doc.hidden || userPaused) return;
        if (!loaded) {
          const deferred = video.querySelectorAll('source[data-src]');
          deferred.forEach(source => { source.src = source.dataset.src; source.removeAttribute('data-src'); });
          if (deferred.length) video.load();
          loaded = true;
        }
        try { await video.play(); } catch (_) { /* Browser autoplay fallback: keep poster and manual play button. */ }
      };
      function playback(playing) {
        const path = playing ? '<path d="M8 5v14M16 5v14"/>' : '<path d="m9 5 10 7-10 7V5Z"/>';
        toggle.querySelector('[data-ffo-video-icon]').innerHTML = '<svg class="ffo-ui-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + path + '</svg>';
        toggle.setAttribute('aria-label', playing ? config.pause : config.play);
        toggle.setAttribute('aria-pressed', String(playing));
      }
      video.addEventListener('play', () => { video.classList.add('is-playing'); playback(true); });
      video.addEventListener('pause', () => { video.classList.remove('is-playing'); playback(false); });
      toggle.addEventListener('click', () => { if (video.paused) { userPaused = false; video.dataset.ffoUserPaused = 'false'; start(); } else { userPaused = true; video.dataset.ffoUserPaused = 'true'; video.pause(); } });
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const saveData = navigator.connection?.saveData;
      if (!reduced && !saveData) {
        start();
        video.addEventListener('loadeddata', () => { if (video.paused && !userPaused) start(); }, { once: true });
      }
      doc.addEventListener('visibilitychange', () => {
        if (doc.hidden) video.pause();
        else if (!reduced && !saveData && !userPaused) start();
      });
      window.addEventListener('pageshow', () => {
        if (!reduced && !saveData && !userPaused) start();
      });
    });
    doc.querySelectorAll('.ffo-story video').forEach(video => video.addEventListener('play', () => {
      doc.querySelectorAll('.ffo-story video').forEach(other => { if (other !== video) other.pause(); });
    }));
  }

  function bindHeroSlider() {
    doc.querySelectorAll('[data-ffo-hero-slider]').forEach(slider => {
      if (slider.dataset.ffoBound) return;
      slider.dataset.ffoBound = 'true';
      const slides = [...slider.querySelectorAll('[data-ffo-hero-slide]')];
      if (slides.length < 2) return;
      const prev = slider.querySelector('[data-ffo-hero-prev]');
      const next = slider.querySelector('[data-ffo-hero-next]');
      const count = slider.querySelector('[data-ffo-hero-count]');
      const video = slider.querySelector('[data-ffo-hero-video]');
      const interval = Math.max(5000, Number(slider.dataset.ffoHeroInterval) || 7000);
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const saveData = navigator.connection?.saveData === true;
      const rotate = slider.dataset.ffoHeroRotate === 'true' && !reduced && !saveData;
      let current = 0, timer = null, hovering = false, touchStart = null;
      const pad = n => String(n).padStart(2, '0');
      function stopTimer() { if (timer !== null) window.clearInterval(timer); timer = null; }
      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        if (count) count.textContent = pad(current + 1) + ' / ' + pad(slides.length);
        if (video) {
          if (current !== 0) video.pause();
          else if (!doc.hidden && video.dataset.ffoUserPaused !== 'true' && !reduced && !saveData) video.play().catch(() => {});
        }
      }
      function schedule() {
        stopTimer();
        if (rotate && !hovering && !doc.hidden) timer = window.setInterval(() => show(current + 1), interval);
      }
      prev?.addEventListener('click', () => { show(current - 1); schedule(); });
      next?.addEventListener('click', () => { show(current + 1); schedule(); });
      slider.addEventListener('mouseenter', () => { hovering = true; stopTimer(); });
      slider.addEventListener('mouseleave', () => { hovering = false; schedule(); });
      slider.addEventListener('focusin', () => { hovering = true; stopTimer(); });
      slider.addEventListener('focusout', event => { if (!slider.contains(event.relatedTarget)) { hovering = false; schedule(); } });
      slider.addEventListener('touchstart', event => { if (event.touches.length === 1) touchStart = event.touches[0].clientX; }, { passive: true });
      slider.addEventListener('touchend', event => { if (touchStart === null) return; const dx = event.changedTouches[0].clientX - touchStart; touchStart = null; if (Math.abs(dx) > 65) { show(current + (dx < 0 ? 1 : -1)); schedule(); } }, { passive: true });
      doc.addEventListener('visibilitychange', schedule);
      doc.addEventListener('shopify:block:select', event => { const slide = event.target.closest?.('[data-ffo-hero-slide]'); if (slide && slider.contains(slide)) { show(slides.indexOf(slide)); hovering = true; stopTimer(); } });
      doc.addEventListener('shopify:block:deselect', event => { if (slider.contains(event.target)) { hovering = false; schedule(); } });
      slider.addEventListener('shopify:section:unload', stopTimer);
      show(0); schedule();
    });
  }
  function bindCatalogue() {
    doc.querySelectorAll('[data-ffo-sort]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
    doc.querySelectorAll('[data-ffo-availability]').forEach(input => input.addEventListener('change', () => {
      let visible = 0;
      doc.querySelectorAll('[data-ffo-product]').forEach(card => {
        card.hidden = input.checked && card.dataset.available !== 'true';
        if (!card.hidden) visible++;
      });
      const count = doc.querySelector('[data-ffo-count]');
      if (count) count.textContent = config.productCount.replace('__COUNT__', visible);
    }));
  }
  function mount() {
    bindHeader(); bindCards(); bindVideo(); bindHeroSlider(); bindCatalogue();
    const total = doc.querySelector('.cart__footer-right');
    if (total) new MutationObserver(refreshCart).observe(total, { childList: true, subtree: true, characterData: true });
  }
  doc.addEventListener('cart:updated', event => event.detail?.cart ? shipping(event.detail.cart) : refreshCart());
  doc.addEventListener('shopify:section:load', mount);
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
})();

(() => {
  function bindEditorial() {
    document.querySelectorAll('[data-ffr-journal]').forEach(root => {
      if (root.dataset.ffrBound) return;
      root.dataset.ffrBound = 'true';
      const grid = root.querySelector('[data-ffr-readings-grid]');
      const counter = root.querySelector('[data-ffr-journal-count]');
      const filters = root.querySelectorAll('[data-ffr-topic-filter]');
      filters.forEach(button => button.addEventListener('click', () => {
        filters.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        let visible = 0;
        grid.querySelectorAll('[data-ffr-topic]').forEach(card => {
          card.hidden = button.dataset.ffrTopicFilter !== 'all' && card.dataset.ffrTopic !== button.dataset.ffrTopicFilter;
          if (!card.hidden) visible++;
        });
        counter.textContent = counter.dataset.countLabel.replace('__COUNT__', String(visible));
        root.querySelector('[data-ffr-journal-empty]').hidden = visible > 0;
      }));
      const dialog = root.querySelector('[data-ffr-reading-dialog]');
      const content = dialog.querySelector('[data-ffr-reading-content]');
      let trigger = null;
      let previousOverflow = '';
      let locked = false;
      function restore() {
        if (!locked) return;
        locked = false;
        document.body.style.overflow = previousOverflow;
        trigger?.focus({ preventScroll: true });
      }
      function close() { dialog.close(); restore(); }
      root.querySelectorAll('[data-ffr-reading-open]').forEach(button => button.addEventListener('click', () => {
        if (dialog.open) return;
        const source = document.getElementById('ffr-reading-' + button.dataset.ffrReadingOpen);
        if (!source) return;
        content.replaceChildren(source.content.cloneNode(true));
        trigger = button;
        previousOverflow = document.body.style.overflow;
        locked = true;
        document.body.style.overflow = 'hidden';
        dialog.showModal();
        dialog.scrollTop = 0;
        dialog.querySelector('[data-ffr-reading-close]').focus({ preventScroll: true });
      }));
      dialog.querySelectorAll('[data-ffr-reading-close]').forEach(button => button.addEventListener('click', close));
      dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
      dialog.addEventListener('close', () => { if (!dialog.open) restore(); });
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) close();
      });
    });
    document.querySelectorAll('[data-ffr-profile]').forEach(link => {
      if (link.dataset.ffrBound) return;
      link.dataset.ffrBound = 'true';
      link.addEventListener('click', () => {
        const select = document.querySelector('[data-ffr-fam-profile]');
        const option = select?.querySelector('[data-profile="' + link.dataset.ffrProfile + '"]');
        if (option) { select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
    const success = document.querySelector('[data-ffr-fam-success]');
    if (success && !success.dataset.ffrBound) { success.dataset.ffrBound = 'true'; success.scrollIntoView({ block: 'center' }); success.focus({ preventScroll: true }); }
  }
  document.addEventListener('shopify:section:load', bindEditorial);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindEditorial, { once: true });
  else bindEditorial();
})();
